import React, { useState } from 'react';

import { cn } from '../../styles/lib/utils';

type GridSpacing = 'cozy' | 'comfy' | 'roomy';
type GridColor = 'white' | 'grey' | 'blue';

const GridContext = React.createContext<{
  spacing?: GridSpacing;
  setPreventXScroll?: (preventXScroll: boolean) => void;
}>({});

function Grid({
  className,
  spacing = 'cozy',
  noScrollContainer = false,
  ...props
}: React.ComponentProps<'table'> & { spacing?: GridSpacing; noScrollContainer?: boolean }) {
  const [preventXScroll, setPreventXScroll] = useState(false);

  const tableElement = (
    <table data-slot="grid" className={cn('min-w-full border-collapse border-spacing-0', className)} {...props} />
  );

  if (noScrollContainer) {
    return <GridContext.Provider value={{ spacing, setPreventXScroll }}>{tableElement}</GridContext.Provider>;
  }

  return (
    <GridContext.Provider value={{ spacing, setPreventXScroll }}>
      <div
        data-slot="grid-container"
        className={cn(
          'relative w-full overflow-x-auto rounded-[8px] border border-grey-30',
          preventXScroll && 'overflow-x-hidden',
        )}
      >
        {tableElement}
      </div>
    </GridContext.Provider>
  );
}

function GridHeader({ className, ...props }: React.ComponentProps<'thead'>) {
  return <thead data-slot="grid-header" className={cn('min-w-full', className)} {...props} />;
}

function GridBody({ className, ...props }: React.ComponentProps<'tbody'>) {
  return <tbody data-slot="grid-body" className={cn('min-w-full', className)} {...props} />;
}

export { Grid, GridHeader, GridBody, GridContext, type GridSpacing, type GridColor };
